import { useNavigate } from 'react-router-dom';
import Footer from '../Footer';

const TermsConditions = () => {
  const navigate = useNavigate();
  return (
    <>
      <div>
        <div className="min-h-screen bg-[#050B18] text-white font-Gabarito flex flex-col">
          <div className="px-6 py-6 md:px-32 bg-[#050B18]">
            <div className="flex flex-wrap items-center justify-between">
              <img
                src="/images/logoWithText.svg"
                className="h-12 cursor-pointer"
                alt="logo"
                onClick={() => navigate('/')}
              />
            </div>
          </div>
          <div className="text-white  font-inika px-6 md:px-20 py-16 w-full leading-7">
            <h1 className="text-4xl font-bold mb-10 text-center">TERMS & CONDITIONS</h1>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-3">1. Acceptance of Terms</h2>
              <p>
                By accessing, registering, or participating in <strong>Decent Den</strong>, you
                agree to be legally bound by these Terms.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-3">2. Eligibility</h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>Minimum age: 18 years</li>
                <li>Must provide accurate and verifiable information</li>
                <li>Only one account per user (no duplicates allowed)</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-3">3. Account Responsibility</h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>You are responsible for all activity under your account</li>
                <li>Sharing login credentials is prohibited</li>
                <li>Fake, misleading, or incomplete profiles may lead to suspension</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-3">4. Nature of Platform</h2>
              <p className="mb-3">
                <strong>Decent Den</strong> is a{' '}
                <strong>digital reality-show experience platform</strong> where users may:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Participate in activities/challenges</li>
                <li>Interact with other users</li>
                <li>Engage with content, rankings, or outcomes</li>
              </ul>
              <p className="mt-3">
                👉 The platform is for <strong>entertainment purposes only</strong>
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-3">5. Participation & Competition Rules</h2>

              <h3 className="text-xl font-semibold mt-4 mb-2">5.1 Fair Participation</h3>
              <ul className="list-disc pl-6 space-y-2">
                <li>Participate honestly</li>
                <li>Avoid manipulation, cheating, or exploiting system loopholes</li>
              </ul>

              <h3 className="text-xl font-semibold mt-4 mb-2">5.2 Anti-Cheating Policy</h3>
              <ul className="list-disc pl-6 space-y-2">
                <li>Multiple/fake accounts</li>
                <li>Automated bots or scripts</li>
                <li>Coordinated manipulation of results</li>
              </ul>
              <p className="mt-2 text-red-400">
                👉 Violation = <strong>immediate disqualification + account ban</strong>
              </p>

              <h3 className="text-xl font-semibold mt-4 mb-2">5.3 Platform Authority</h3>
              <ul className="list-disc pl-6 space-y-2">
                <li>Modify rules</li>
                <li>Change formats</li>
                <li>Adjust scoring systems</li>
                <li>Remove participants</li>
              </ul>
              <p className="mt-2">
                👉 <strong>All decisions are final and binding</strong>
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-3">
                6. Voting, Ranking & Results (If Applicable)
              </h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>Internal algorithms</li>
                <li>User engagement</li>
                <li>Platform-defined criteria</li>
              </ul>
              <p className="mt-3">The exact calculation method:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>May not be disclosed</li>
                <li>Can change anytime without notice</li>
              </ul>
              <p className="mt-2">👉 Users cannot challenge or dispute results.</p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-3">
                7. Winner Selection & Rewards (If Applicable)
              </h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>
                  Winners are determined solely by <strong>Decent Den</strong>
                </li>
                <li>Tie → platform decides tie-breaker</li>
                <li>Suspicious activity → winner may be disqualified</li>
              </ul>
              <p className="mt-3">👉 Rewards (if any):</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Are non-transferable</li>
                <li>Cannot be exchanged for cash unless stated</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-3">8. Disqualification & Suspension</h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>Rule violations</li>
                <li>Misconduct or abusive behavior</li>
                <li>Suspicious or fraudulent activity</li>
              </ul>
              <p className="mt-2 text-red-400">👉 No prior notice required</p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-3">9. User Conduct</h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>Post abusive, offensive, or illegal content</li>
                <li>Harass or threaten others</li>
                <li>Upload copyrighted or stolen material</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-3">10. Content Ownership & Usage Rights</h2>
              <p>
                By using the platform, you grant <strong>Decent Den</strong>:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>
                  A <strong>worldwide, royalty-free, perpetual license</strong> to:
                </li>
                <li>Use, display, reproduce, and distribute your content</li>
                <li>Use your name, image, and submissions</li>
              </ul>
              <p className="mt-3">👉 For:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Promotions</li>
                <li>Marketing</li>
                <li>Platform growth</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-3">11. Intellectual Property</h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>
                  All platform elements belong to <strong>Decent Den</strong>
                </li>
                <li>Unauthorized use is strictly prohibited</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-3">12. No Warranty</h2>
              <p>
                The platform is provided <strong>“as is”</strong> without guarantees:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>No guarantee of accuracy</li>
                <li>No guarantee of uninterrupted access</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-3">13. Limitation of Liability</h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>User disputes</li>
                <li>Technical failures</li>
                <li>Loss of data or participation results</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-3">14. Termination</h2>
              <p>We may suspend or terminate access:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Without prior notice</li>
                <li>At our sole discretion</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-3">15. Changes to Platform</h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>Modify features</li>
                <li>Add/remove functionality</li>
                <li>Update rules anytime</li>
              </ul>
            </section>
          </div>
        </div>

        <Footer />
      </div>
    </>
  );
};

export default TermsConditions;
